/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  SaveSubscriptionPlanMutationRequest,
  SaveSubscriptionPlanMutationResponse,
  SaveSubscriptionPlanPathParams,
} from "../types/SaveSubscriptionPlan.ts"

export const saveSubscriptionPlanMutationKey = () =>
  [
    { url: "/v1/organization-settings/save-subscription-plan/:organizationId" },
  ] as const

export type SaveSubscriptionPlanMutationKey = ReturnType<
  typeof saveSubscriptionPlanMutationKey
>

/**
 * @summary Save new subscription plan
 * {@link /v1/organization-settings/save-subscription-plan/:organizationId}
 */
export async function saveSubscriptionPlan(
  organizationId: SaveSubscriptionPlanPathParams["organizationId"],
  data: SaveSubscriptionPlanMutationRequest,
  config: Partial<RequestConfig<SaveSubscriptionPlanMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    SaveSubscriptionPlanMutationResponse,
    ResponseErrorConfig<Error>,
    SaveSubscriptionPlanMutationRequest
  >({
    method: "POST",
    url: `/v1/organization-settings/save-subscription-plan/${organizationId}`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function saveSubscriptionPlanMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<SaveSubscriptionPlanMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = saveSubscriptionPlanMutationKey()
  return mutationOptions<
    ResponseConfig<SaveSubscriptionPlanMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      organizationId: SaveSubscriptionPlanPathParams["organizationId"]
      data: SaveSubscriptionPlanMutationRequest
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ organizationId, data }) => {
      return saveSubscriptionPlan(organizationId, data, config)
    },
  })
}

/**
 * @summary Save new subscription plan
 * {@link /v1/organization-settings/save-subscription-plan/:organizationId}
 */
export function useSaveSubscriptionPlan<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<SaveSubscriptionPlanMutationResponse>,
      ResponseErrorConfig<Error>,
      {
        organizationId: SaveSubscriptionPlanPathParams["organizationId"]
        data: SaveSubscriptionPlanMutationRequest
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<SaveSubscriptionPlanMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? saveSubscriptionPlanMutationKey()

  const baseOptions = saveSubscriptionPlanMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<SaveSubscriptionPlanMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      organizationId: SaveSubscriptionPlanPathParams["organizationId"]
      data: SaveSubscriptionPlanMutationRequest
    },
    TContext
  >

  return useMutation<
    ResponseConfig<SaveSubscriptionPlanMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      organizationId: SaveSubscriptionPlanPathParams["organizationId"]
      data: SaveSubscriptionPlanMutationRequest
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<SaveSubscriptionPlanMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      organizationId: SaveSubscriptionPlanPathParams["organizationId"]
      data: SaveSubscriptionPlanMutationRequest
    },
    TContext
  >
}
